import React from 'react';

/**
 * NeedHelpStickyBar — fixed-position bar pinned to the bottom of the viewport
 * on public/marketing screens. Surfaces the single support email channel,
 * styled to match the page palette so it never feels like a foreign overlay.
 *
 * Usage:
 *   <NeedHelpStickyBar />                  // default: blue glow (provider pages)
 *   <NeedHelpStickyBar variant="purple" /> // purple glow (customer pages)
 *
 * Email is the only contact channel surfaced here — phone is intentionally
 * absent. Gateway is the single source of truth for the full contact block.
 */
const NeedHelpStickyBar = ({ variant = 'blue', testId = 'need-help-bar' }) => {
  // Variant palette — controls glow + link color + top border.
  //   blue (default) — provider pages
  //   purple         — customer pages
  //   green          — network contractor pages
  const variantStyles = {
    blue: {
      linkColor: '#60a5fa',
      glow: '0 0 8px rgba(96, 165, 250, 0.65), 0 0 18px rgba(96, 165, 250, 0.35)',
      borderTop: '1px solid rgba(59, 130, 246, 0.25)',
    },
    purple: {
      linkColor: '#7e22ce',
      glow: '0 0 8px rgba(168, 85, 247, 0.55), 0 0 18px rgba(168, 85, 247, 0.30)',
      borderTop: '1px solid rgba(168, 85, 247, 0.25)',
    },
    green: {
      linkColor: '#34d399',
      glow: '0 0 8px rgba(52, 211, 153, 0.65), 0 0 18px rgba(16, 185, 129, 0.35)',
      borderTop: '1px solid rgba(16, 185, 129, 0.30)',
    },
  };
  const { linkColor, glow, borderTop } = variantStyles[variant] || variantStyles.blue;

  return (
    <div
      data-testid={testId}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        padding: '10px 16px',
        background: 'rgba(2, 6, 23, 0.85)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        borderTop,
        textAlign: 'center',
        fontSize: '13px',
        color: 'rgba(226, 232, 240, 0.85)',
      }}
    >
      Need help?{' '}
      <a
        href="mailto:support@remoddash.com"
        data-testid={`${testId}-email`}
        style={{
          color: linkColor,
          fontWeight: 700,
          textDecoration: 'none',
          textShadow: glow,
        }}
      >
        support@remoddash.com
      </a>
    </div>
  );
};

export default NeedHelpStickyBar;
